import React, { useState } from "react"
import {
  TabButton,
  TabList,
  TabPanel,
  TabPanels,
  TabsContainer,
} from "~styled/tab"

interface Tab {
  id: string
  label: string
  content: React.ReactNode
}

interface TabsProps {
  tabs: Tab[]
  defaultActiveTabId?: string
  isDisabled: boolean
}

const Tabs = ({ tabs, defaultActiveTabId, isDisabled }: TabsProps) => {
  const [activeTabId, setActiveTabId] = useState<string>(
    defaultActiveTabId || tabs[0]?.id,
  )

  return (
    <TabsContainer>
      <TabList>
        {tabs.map(tab => (
          <TabButton
            key={tab.id}
            $isActive={tab.id === activeTabId}
            onClick={() => setActiveTabId(tab.id)}
            disabled={isDisabled}
          >
            {tab.label}
          </TabButton>
        ))}
      </TabList>

      {/* Tab Panels */}
      <TabPanels>
        {tabs.map(
          tab =>
            tab.id === activeTabId && (
              <TabPanel key={tab.id}>{tab.content}</TabPanel>
            ),
        )}
      </TabPanels>
    </TabsContainer>
  )
}
export default Tabs
